import React from 'react';
import Counter from '../ReusableComponents/counter';

//MUI
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { Container } from '@mui/system';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import Button from '@mui/material/Button';

//images
import im2 from '../../assets/images/SDG/2.jpg';
import im3 from '../../assets/images/SDG/3.jpg';
import im6 from '../../assets/images/SDG/6.jpg';
import im7 from '../../assets/images/SDG/7.jpg';
import im9 from '../../assets/images/SDG/9.jpg';
import im10 from '../../assets/images/SDG/10.jpg';
import im12 from '../../assets/images/SDG/12.jpg';
import im13 from '../../assets/images/SDG/13.jpg';
import im14 from '../../assets/images/SDG/14.jpg';
import im15 from '../../assets/images/SDG/15.jpg';
import bg from '../../assets/images/background.svg'
import P6 from '../../assets/images/cardImages/environment.jpg';
import P6_small from '../../assets/images/cardImages/mobile/environment.jpg';
import WestIcon from '@mui/icons-material/West';
import EastIcon from '@mui/icons-material/East';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import DeleteIcon from '@mui/icons-material/Delete';
import SolarPowerIcon from '@mui/icons-material/SolarPower';
import RecyclingIcon from '@mui/icons-material/Recycling';
import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf';

//chart js
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';


const counterData = [
    {
        "num": 100,
        "label": "Water Positive Index",
        "icon": WaterDropIcon,
        "prefix": "",
        "isdecimal": false,
        "suffix": "%"
    },
    {
        "num": 37,
        "label": "Electricity Consumed from renewable sources",
        "icon": SolarPowerIcon,
        "prefix": "",
        "isdecimal": false,
        "suffix": "%"
    },
    {
        "num": 0,
        "label": "Energy productivity 122.9% for Auto Sector and 117.7% for Farm Equipment Sector compared to F09",
        "icon": EnergySavingsLeafIcon,
        "prefix": "Surpassed EP100 commitment",
        "isdecimal": false,
        "suffix": ""
    },
    {
        "num": 83,
        "label": "Locations are ‘Zero waste to landfill’ certified",
        "icon": DeleteIcon,
        "prefix": "",
        "isdecimal": false,
        "suffix": "%"
    },
    {
        "num": 273,
        "label": "Invested in various environmental initiatives",
        "icon": RecyclingIcon,
        "prefix": "INR ",
        "isdecimal": false,
        "suffix": " million"
    },
    {
        "num": 98912,
        "label": "Energy savings",
        "icon": EnergySavingsLeafIcon,
        "prefix": "",
        "isdecimal": false,
        "suffix": " GJ"
    }
]

const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

ChartJS.register(ArcElement, Tooltip, Legend);

//------------------------------------------------------------------------------
export const options1 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        title: {
            display: false,
            text: 'Scope 1 & Scope 2 Emissions Intensity',
        },
        legend: {
            position: 'top',
            labels: {
                font: {
                    family: 'Georama'
                }
            }
        },
        datalabels: {
            anchor: 'center',
            align: 'bottom',
            formatter: (value, context) => {
                let keys = Object.keys(context.dataset.data)
                let key = keys[context.dataIndex]
                if (context.dataset.data[key] !== 0) {
                    return context.dataset.data[key].toLocaleString('en-In');;
                }

            },
            padding: -10,
            color: "white",
            font: {
                family: 'Georama',
                size: 14,
                weight: 'bold',

            }
        }
    },
    scales: {
        x: {
            grid: {
                display: false
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
        y: {
            display: true,

            grid: {
                display: true,
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
    },
};

const labels1 = ['FY24', 'FY25'];

export const data1 = {
    labels1,
    datasets: [
        {
            label: 'Scope 1 & Scope 2 Emissions intensity',
            data: {
                "FY24": 3.09,
                "FY25": 2.73
            },
            backgroundColor: '#4d4d4f',
            barThickness: 55
        }
    ],
};

//--------------------------------------------------------------------------------------
export const options2 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        title: {
            display: false,
            text: 'Water Discharge',
        },
        legend: {
            position: 'top',
            labels: {
                font: {
                    family: 'Georama'
                }
            }
        },
        datalabels: {
            anchor: 'center',
            align: 'bottom',
            formatter: (value, context) => {
                let keys = Object.keys(context.dataset.data)
                let key = keys[context.dataIndex]
                if (context.dataset.data[key] !== 0) {
                    return context.dataset.data[key].toLocaleString('en-In');;
                }

            },
            padding: -10,
            color: "white",
            font: {
                family: 'Georama',
                size: 14,
                weight: 'bold',

            }
        }
    },
    scales: {
        x: {
            grid: {
                display: false
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
        y: {
            display: true,

            grid: {
                display: true,
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
    },
};

const labels2 = ['FY24', 'FY25'];

export const data2 = {
    labels2,
    datasets: [
        {
            label: 'Water consumption intensity',
            data: {
                "FY24": 23.34,
                "FY25": 21.57
            },
            backgroundColor: '#4d4d4f',
            barThickness: 55
        }
    ],
};

//----------------------------------------------------------------------------------------
export const options3 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        title: {
            display: false,
            text: 'Energy intensity per crore rupee of turnover ',
        },
        legend: {
            position: 'top',
            labels: {
                font: {
                    family: 'Georama'
                }
            }
        },
        datalabels: {
            anchor: 'center',
            align: 'bottom',
            formatter: (value, context) => {
                let keys = Object.keys(context.dataset.data)
                let key = keys[context.dataIndex]
                if (context.dataset.data[key] !== 0) {
                    return context.dataset.data[key].toLocaleString('en-In');;
                }

            },
            padding: -10,
            color: "white",
            font: {
                family: 'Georama',
                size: 14,
                weight: 'bold',

            }
        }
    },
    scales: {
        x: {
            grid: {
                display: false
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
        y: {
            display: true,

            grid: {
                display: true,
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
    },
};

const labels3 = ['FY23', 'FY24', 'FY25', 'FY26'];

export const data3 = {
    labels3,
    datasets: [
        {
            label: 'Energy intensity',
            data: {
                "FY23": 29.05,
                "FY24": 25.84,
                "FY25": 24.72,
                "FY26": 22.63
            },
            backgroundColor: '#4d4d4f',
            barThickness: 55
        }
    ],
};

//--------------------------------------------------------------------------------

export const options5 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        title: {
            display: false,
            text: 'Scope 3 Emissions Intensity',
        },
        legend: {
            position: 'top',
            labels: {
                font: {
                    family: 'Georama'
                }
            }
        },
        datalabels: {
            anchor: 'center',
            align: 'bottom',
            formatter: (value, context) => {
                let keys = Object.keys(context.dataset.data)
                let key = keys[context.dataIndex]
                if (context.dataset.data[key] !== 0) {
                    return context.dataset.data[key].toLocaleString('en-In');;
                }

            },
            padding: -10,
            color: "white",
            font: {
                family: 'Georama',
                size: 14,
                weight: 'bold',

            }
        }
    },
    scales: {
        x: {
            grid: {
                display: false
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
        y: {
            display: true,

            grid: {
                display: true,
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
    },
};

const labels5 = ['FY24', 'FY25'];

export const data5 = {
    labels5,
    datasets: [
        {
            label: 'Scope 3 Emission intensity',
            data: {
                "FY24": 944.14,
                "FY25": 775.85
            },
            backgroundColor: '#4d4d4f',
            barThickness: 55
        }
    ],
};


const StyledBox = styled(Box)`
  ${({ theme }) => `
  cursor: pointer;
  transition: ${theme.transitions.create(['transform'], {
    duration: theme.transitions.duration.standard,
})};
  &:hover {
    transform: scale(1.8);
  }
  `}
`;



const Sectionc6 = () => {

    const [expanded1, setExpanded1] = React.useState(false);
    const handleExpandClick1 = () => {
        setExpanded1(!expanded1);
    };

    const [expanded2, setExpanded2] = React.useState(false);
    const handleExpandClick2 = () => {
        setExpanded2(!expanded2);
    };

    const [expanded3, setExpanded3] = React.useState(false);
    const handleExpandClick3 = () => {
        setExpanded3(!expanded3);
    };



    const [expanded4, setExpanded4] = React.useState(false);
    const handleExpandClick4 = () => {
        setExpanded4(!expanded4);
    };

    const [expanded5, setExpanded5] = React.useState(false);
    const handleExpandClick5 = () => {
        setExpanded5(!expanded5);
    };

    const [expanded6, setExpanded6] = React.useState(false);
    const handleExpandClick6 = () => {
        setExpanded6(!expanded6);
    };

    const [expanded7, setExpanded7] = React.useState(false);
    const handleExpandClick7 = () => {
        setExpanded7(!expanded7);
    };

    const [expanded8, setExpanded8] = React.useState(false);
    const handleExpandClick8 = () => {
        setExpanded8(!expanded8);
    };

    const [expanded9, setExpanded9] = React.useState(false);
    const handleExpandClick9 = () => {
        setExpanded9(!expanded9);
    };

    const [expanded9g, setExpanded9g] = React.useState(false);
    const handleExpandClick9g = () => {
        setExpanded9g(!expanded9g);
    };

    const [expanded10, setExpanded10] = React.useState(false);
    const handleExpandClick10 = () => {
        setExpanded10(!expanded10);
    };

    const [expanded11, setExpanded11] = React.useState(false);
    const handleExpandClick11 = () => {
        setExpanded11(!expanded11);
    };

    const [expanded12, setExpanded12] = React.useState(false);
    const handleExpandClick12 = () => {
        setExpanded12(!expanded12);
    };

    const [expanded13, setExpanded13] = React.useState(false);
    const handleExpandClick13 = () => {
        setExpanded13(!expanded13);
    };




    const [expanded15, setExpanded15] = React.useState(false);
    const handleExpandClick15 = () => {
        setExpanded15(!expanded15);
    };

    const [expanded16, setExpanded16] = React.useState(false);
    const handleExpandClick16 = () => {
        setExpanded16(!expanded16);
    };


    const [expanded17, setExpanded17] = React.useState(false);
    const handleExpandClick17 = () => {
        setExpanded17(!expanded17);
    };

    const [expanded18, setExpanded18] = React.useState(false);
    const handleExpandClick18 = () => {
        setExpanded18(!expanded18);
    };

    const [expanded19, setExpanded19] = React.useState(false);
    const handleExpandClick19 = () => {
        setExpanded19(!expanded19);
    };

    const [expanded20, setExpanded20] = React.useState(false);
    const handleExpandClick20 = () => {
        setExpanded20(!expanded20);
    };

    const [expanded21, setExpanded21] = React.useState(false);
    const handleExpandClick21 = () => {
        setExpanded21(!expanded21);
    };

    const [expanded22, setExpanded22] = React.useState(false);
    const handleExpandClick22 = () => {
        setExpanded22(!expanded22);
    };

    const [expanded23, setExpanded23] = React.useState(false);
    const handleExpandClick23 = () => {
        setExpanded23(!expanded23);
    };

    const [expand, setExpand] = React.useState(false);
    const expandAll = () => {
        setExpand(true); setExpanded1(true); setExpanded2(true); setExpanded3(true); setExpanded4(true); setExpanded5(true); setExpanded6(true); setExpanded7(true); setExpanded8(true); setExpanded9(true); setExpanded9g(true); setExpanded10(true); setExpanded11(true); setExpanded12(true); setExpanded13(true); setExpanded15(true); setExpanded16(true); setExpanded17(true); setExpanded18(true); setExpanded19(true); setExpanded20(true); setExpanded21(true); setExpanded22(true); setExpanded23(true);
    };
    const closeAll = () => {
        setExpand(false); setExpanded1(false); setExpanded2(false); setExpanded3(false); setExpanded4(false); setExpanded5(false); setExpanded6(false); setExpanded7(false); setExpanded8(false); setExpanded9(false); setExpanded9g(false); setExpanded10(false); setExpanded11(false); setExpanded12(false); setExpanded13(false); setExpanded15(false); setExpanded16(false); setExpanded17(false); setExpanded18(false); setExpanded19(false); setExpanded20(false); setExpanded22(false); setExpanded23(false);
    };



    return (
        <Container>
            <Box mt={3} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button startIcon={<WestIcon />} sx={{ fontWeight: 'bold' }} href='/sectionc5'>
                    Previous
                </Button>
                <Button endIcon={<EastIcon />} sx={{ fontWeight: 'bold' }} href='/sectionc7'>
                    Next
                </Button>
            </Box>
            <Box mt={3} sx={{
                display: 'flex',
                alignItems: 'center',
                height: { xs: '150px', md: '300px' },
                backgroundImage: `url(${bg})`,
                backgroundSize: 'cover',
                borderRadius: '8px'
            }}>
                <Box px={5} py={3} sx={{ width: '100%' }}>
                    <Typography sx={{ typography: { xs: 'h5', md: 'h4' }, color: "#ffffff" }}>
                        Principle 6
                    </Typography>
                    <Typography mt={2} sx={{ typography: { xs: 'body1', md: 'h6' }, color: "#ffffff" }}>
                        Environment
                    </Typography>
                    <Box mt={2} sx={{ display: { xs: 'none', lg: 'flex' } }}>
                        <Typography variant='body1' sx={{ color: "#ffffff" }}>
                            Businesses should respect and make efforts to protect and restore the environment
                        </Typography>
                    </Box>
                    <Box mt={3} sx={{ display: { xs: 'none', lg: 'flex' } }}>
                        <StyledBox><img src={im2} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im3} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im6} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im7} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im9} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im10} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im12} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im13} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im14} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im15} height="40" alt="svg" /></StyledBox>
                    </Box>
                </Box>
                <Box sx={{
                    backgroundImage: { xs: `url(${P6_small})`, sm: `url(${P6})` },
                    backgroundSize: 'cover',
                    borderRadius: '0 8px 8px 0',
                    height: { xs: '150px', md: '300px' },
                    width: '100%'
                }}>
                </Box>
            </Box>
            <Box px={4} py={6} mt={{ xs: 4, md: 8 }} sx={{ backgroundColor: '#e6e7e8', borderRadius: '8px' }}>
                <Box mb={6} display="flex" justifyContent="center">
                    <Typography className='heading' variant='h4' sx={{ color: "#e31837", fontSize: "34px", fontWeight: "900" }}>
                        Highlights
                    </Typography>
                </Box>
                <Box>
                    <Counter data={counterData} />
                </Box>
            </Box>
            <Box mt={5} sx={{ textAlign: "right" }}>
                <button onClick={!expand ? expandAll : closeAll} className="custom-button">
                    <span>
                        {!expand ? 'Expand All' : "Close All"}
                        {!expand ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                    </span>
                </button>
            </Box>
            <Box mt={4}>
                <Typography className='heading' variant='h4' sx={{ fontSize: '28px', color: "#e31837" }}>
                    Essential Indicators
                </Typography>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            1. Details of total energy consumption (in Joules or multiples) and energy intensity
                            <ExpandMore
                                expand={expanded1}
                                onClick={handleExpandClick1}
                                aria-expanded={expanded1}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                            <ExpandMore
                                expand={expanded9g}
                                onClick={handleExpandClick9g}
                                aria-expanded={expanded9g}
                                aria-label="show more"
                            >
                                <AssessmentOutlinedIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded1} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell><strong>Parameter</strong></TableCell>
                                        <TableCell align="center"><strong>Please specify unit</strong></TableCell>
                                        <TableCell align="center"><strong>FY26</strong></TableCell>
                                        <TableCell align="center"><strong>FY25</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" colSpan={4} align='center' sx={{ backgroundColor: "#e6e7e8" }}>
                                            <strong>From Renewable Sources</strong>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row" sx={{ width: 550 }}>
                                            Total electricity consumption (A)
                                        </TableCell>
                                        <TableCell align="center">GJ - Giga Joules</TableCell>
                                        <TableCell align="center">6,51,116</TableCell>
                                        <TableCell align="center">5,31,663</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">
                                            Total fuel consumption (B)
                                        </TableCell>
                                        <TableCell align="center">GJ - Giga Joules</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">
                                            Energy consumption through other sources (C)
                                        </TableCell>
                                        <TableCell align="center">GJ - Giga Joules</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">
                                            <strong>Total energy consumed from renewable sources (A+B+C)</strong>
                                        </TableCell>
                                        <TableCell align="center"><strong>GJ - Giga Joules</strong></TableCell>
                                        <TableCell align="center"><strong>6,51,116</strong></TableCell>
                                        <TableCell align="center"><strong>5,31,663</strong></TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row" colSpan={4} align='center' sx={{ backgroundColor: "#e6e7e8" }}>
                                            <strong>From Non-Renewable Sources</strong>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row" sx={{ width: 550 }}>
                                            Total electricity consumption (D)
                                        </TableCell>
                                        <TableCell align="center">GJ - Giga Joules</TableCell>
                                        <TableCell align="center">13,46,774</TableCell>
                                        <TableCell align="center">12,56,687</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">
                                            Total fuel consumption (E)
                                        </TableCell>
                                        <TableCell align="center">GJ - Giga Joules</TableCell>
                                        <TableCell align="center">12,96,331</TableCell>
                                        <TableCell align="center">10,90,636</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">
                                            Energy consumption through other sources (F)
                                        </TableCell>
                                        <TableCell align="center">GJ - Giga Joules</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">
                                            <strong>Total energy consumed from non-renewable sources (D+E+F)</strong>
                                        </TableCell>
                                        <TableCell align="center"><strong>GJ - Giga Joules</strong></TableCell>
                                        <TableCell align="center"><strong>26,43,105</strong></TableCell>
                                        <TableCell align="center"><strong>24,47,323</strong></TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">
                                            <strong>Total energy consumed (A+B+C+D+E+F)</strong>
                                        </TableCell>
                                        <TableCell align="center"><strong>GJ - Giga Joules</strong></TableCell>
                                        <TableCell align="center"><strong>32,94,221</strong></TableCell>
                                        <TableCell align="center"><strong>28,78,986</strong></TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">
                                            <strong>Energy intensity per rupee of turnover</strong> (Total energy consumption/ revenue from operations)
                                        </TableCell>
                                        <TableCell align="center">GJ - Giga Joules/ Cr. rupee of turnover</TableCell>
                                        <TableCell align="center">22.63</TableCell>
                                        <TableCell align="center">24.72</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">
                                            <strong>Energy intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP)^</strong> (Total energy
                                            consumption/ revenue from operations adjusted for PPP)
                                        </TableCell>
                                        <TableCell align="center">
                                            GJ/ Cr. rupee of turnover<br />
                                            adjusted for Purchasing Power Parity
                                        </TableCell>
                                        <TableCell align="center">460.27</TableCell>
                                        <TableCell align="center">510.62</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">
                                            <strong>Energy intensity in terms of physical output</strong>
                                        </TableCell>
                                        <TableCell align="center">
                                            GJ - Giga Joules/ Eq Vehicle<br />
                                            GJ - Giga Joules/ Eq Tractor<br />
                                            GJ - Giga Joules/ Ton of packaging
                                        </TableCell>
                                        <TableCell align="center">
                                            Automotive Sector: 1.036<br />
                                            Farm Sector: 1.042<br />
                                            Spares Business Unit: 1.038
                                        </TableCell>
                                        <TableCell align="center">
                                            Automotive Sector: 1.117<br />
                                            Farm Sector: 1.146<br />
                                            Spares Business Unit: 1.217
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">
                                            Energy intensity (optional) - the relevant metric may be selected by the entity
                                        </TableCell>
                                        <TableCell align="center">GJ - Giga Joules</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>
                                </TableBody>

                            </Table>
                        </TableContainer>
                        <Box mb={5} mt={2}>
                            <Typography variant='body2'>
                                * Sources of renewable electricity include solar, wind, group captive etc. International Renewable Energy Certificates ("IRECs") have not been included under energy consumption from renewable sources. In FY 2026-27, M&amp;M purchased RECs equivalent to 123,736 (GJ). Based on GHG Protocol and RE100 guidelines, after including the attributes of 123,736 IRECs, the total electricity consumption from renewable sources (A) becomes 7,74,852 GJ and total electricity consumption from non-renewable sources (D) stands at 12,23,038 GJ for FY 2025-26.
                                <br /><br />
                                ^ For India PPP conversion factor is 20.34 &amp; 20.66 for the year 2026 and 2025 respectively as per Implied PPP conversion rate available at https://www.imf.org/external/datamapper/PPPEX@WEO/OEMDC/IND
                                <br /><br />
                                <strong>Note: Indicate if any independent assessment/ evaluation/ assurance hasbeen carried out by an external agency? (Y/N) If yes, name of the external agency:</strong>
                                <br />
                                Yes, DNV Business Assurance India Private Limited
                            </Typography>
                        </Box>
                    </Box>
                </Collapse>
                <Collapse in={expanded9g} timeout="auto" unmountOnExit>
                    <Box sx={{ mx: 'auto', width: { md: '100%', lg: '60%' } }} mt={4} mb={8}>
                        <Box p={3} sx={{ backgroundColor: '#e31837' }} display='flex' flexDirection='column' alignItems='center' justifyContent='center'>
                            <Box>
                                <Typography variant='h6' sx={{ color: 'white', fontWeight: 'bold' }}>
                                    Energy intensity per crore rupee of turnover
                                </Typography>
                            </Box>
                            <Box mt={1}>
                                <Typography variant='body2' sx={{ color: 'white' }}>
                                    <strong>8.45%</strong> reduction as compared to FY25
                                </Typography>
                            </Box>
                        </Box>
                        <Box p={6} sx={{ border: "1.5px solid #e31837 ", height: '400px' }}>
                            <Bar options={options3} data={data3} />
                        </Box>

                    </Box>
                </Collapse>
            </Box>
            <Box mt={4} mb={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        2. Does the entity have any sites/ facilities identified as designated consumers (DCs) under the Performance, Achieve and Trade
                        (PAT) Scheme of the Government of India? (Yes/ No) If yes, disclose whether targets set under the PAT scheme have been
                        achieved. In case targets have not been achieved, provide the remedial action taken, if any
                        <ExpandMore
                            expand={expanded2}
                            onClick={handleExpandClick2}
                            aria-expanded={expanded2}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded2} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            No
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={4} mb={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        3. Provide details of the following disclosures related to water, in the following format
                        <ExpandMore
                            expand={expanded3}
                            onClick={handleExpandClick3}
                            aria-expanded={expanded3}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded3} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" aria-label="Water withdrawal">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell><strong>Parameter</strong></TableCell>
                                        <TableCell align="center"><strong>Please specify unit</strong></TableCell>
                                        <TableCell align="center"><strong>FY26</strong></TableCell>
                                        <TableCell align="center"><strong>FY25</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" sx={{ width: 550, backgroundColor: "#e6e7e8" }} colSpan={4}>
                                            <strong>Water Withdrawal by Source (in Kilolitres)</strong>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">(i) Surface water</TableCell>
                                        <TableCell align="center">Kilolitres</TableCell>
                                        <TableCell align="center">57,744</TableCell>
                                        <TableCell align="center">69,425</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">(ii) Groundwater</TableCell>
                                        <TableCell align="center">Kilolitres</TableCell>
                                        <TableCell align="center">6,42,659</TableCell>
                                        <TableCell align="center">5,49,670</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">(iii) Third party water</TableCell>
                                        <TableCell align="center">Kilolitres</TableCell>
                                        <TableCell align="center">23,28,666</TableCell>
                                        <TableCell align="center">22,64,188</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">(iv) Seawater/desalinated water</TableCell>
                                        <TableCell align="center">Kilolitres</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">(v) Others</TableCell>
                                        <TableCell align="center">Kilolitres</TableCell>
                                        <TableCell align="center">21,542</TableCell>
                                        <TableCell align="center">27,228</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row"><strong>Total volume of water withdrawal (in kilolitres) (i + ii + iii + iv + v)</strong></TableCell>
                                        <TableCell align="center"><strong>Kilolitres</strong></TableCell>
                                        <TableCell align="center"><strong>30,50,611</strong></TableCell>
                                        <TableCell align="center"><strong>29,10,511</strong></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row"><strong>Total volume of water consumption (in kilolitres)</strong></TableCell>
                                        <TableCell align="center"><strong>Kilolitres</strong></TableCell>
                                        <TableCell align="center"><strong>30,50,611</strong></TableCell>
                                        <TableCell align="center"><strong>28,80,263</strong></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">
                                            <strong>Water intensity per rupee of turnover</strong> (Total water consumption/ revenue from operations)
                                        </TableCell>
                                        <TableCell align="center">Kilolitres/ Cr. Rupee of turnover</TableCell>
                                        <TableCell align="center">20.96</TableCell>
                                        <TableCell align="center">24.73</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">
                                            <strong>Water intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP)*</strong> (Total water consumption/ revenue from operations adjusted for PPP)
                                        </TableCell>
                                        <TableCell align="center">
                                            Kilolitres/ Cr. Rupee of turnover adjusted for Purchasing Power Parity
                                        </TableCell>
                                        <TableCell align="center">426.23</TableCell>
                                        <TableCell align="center">510.85</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row"><strong>Water intensity in terms of physical output</strong></TableCell>
                                        <TableCell align="center">
                                            Kilolitres/ Eq Vehicle<br />
                                            Kilolitres/ Eq Tractor<br />
                                            Kilolitres/ Ton of packaging
                                        </TableCell>
                                        <TableCell align="center">
                                            Automotive Sector: 0.917<br />
                                            Farm Equipment Sector: 0.641<br />
                                            Spares Business Unit: 3.375
                                        </TableCell>
                                        <TableCell align="center">
                                            Automotive Sector: 1.011<br />
                                            Farm Equipment Sector: 0.689<br />
                                            Spares Business Unit: 4.158
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">
                                            Water intensity (optional) - the relevant metric may be selected by the entity
                                        </TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>
                                </TableBody>

                            </Table>
                        </TableContainer>
                        <Box mb={5} mt={2}>
                            <Typography variant='body2'>
                                * For India PPP conversion factor is 20.34 &amp; 20.66 for the year 2026 and 2025 respectively as per Implied PPP conversion rate available at <a href="https://www.imf.org/external/datamapper/PPPEX@WEO/OEMDC/IND" target='_blank' rel="noreferrer noopener">https://www.imf.org/external/datamapper/PPPEX@WEO/OEMDC/IND</a>
                                <br></br><br></br>
                                <strong>Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N) If yes, name of the external agency.</strong>
                                <br></br>
                                Yes, DNV Business Assurance India Private Limited
                            </Typography>
                        </Box>
                    </Box>
                </Collapse>
            </Box>

            <Box mt={4} mb={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        4. Provide the following details related to water discharged for current and previous FY:
                        <ExpandMore
                            expand={expanded13}
                            onClick={handleExpandClick13}
                            aria-expanded={expanded13}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded13} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" aria-label="Water withdrawal">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>Parameter</strong></TableCell>
                                        <TableCell align="center"><strong>Please specify unit</strong></TableCell>
                                        <TableCell align="center"><strong>FY26</strong></TableCell>
                                        <TableCell align="center"><strong>FY25</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" sx={{ width: 550, backgroundColor: "#e6e7e8" }} colSpan={4}>
                                            <strong>Water discharge by destination and level of treatment (in Kilolitres)</strong>
                                        </TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" sx={{ width: 550 }} >
                                            (i) To Surface water
                                        </TableCell>
                                        <TableCell align="center">Kilolitres</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            - No treatment
                                        </TableCell>
                                        <TableCell align="center">Kilolitres</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            - With treatment - please specify level of treatment
                                        </TableCell>
                                        <TableCell align="center">Kilolitres</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" sx={{ width: 550 }}>
                                            (ii) To Groundwater
                                        </TableCell>
                                        <TableCell align="center">Kilolitres</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            - No treatment
                                        </TableCell>
                                        <TableCell align="center">Kilolitres</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            - With treatment - please specify level of treatment
                                        </TableCell>
                                        <TableCell align="center">Kilolitres</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" sx={{ width: 550 }} >
                                            (iii) To Seawater
                                        </TableCell>
                                        <TableCell align="center">Kilolitres</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            - No treatment
                                        </TableCell>
                                        <TableCell align="center">Kilolitres</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            - With treatment - please specify level of treatment
                                        </TableCell>
                                        <TableCell align="center">Kilolitres</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" sx={{ width: 550 }}>
                                            (iv) Sent to third-parties
                                        </TableCell>
                                        <TableCell align="center">Kilolitres</TableCell>
                                        <TableCell align="center">–*</TableCell>
                                        <TableCell align="center">30,248</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            - No treatment
                                        </TableCell>
                                        <TableCell align="center">Kilolitres</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            - With treatment - please specify level of treatment
                                            (Tertiary Treatment, through effluent treatment plant)
                                        </TableCell>
                                        <TableCell align="center">Kilolitres</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">30,248</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" sx={{ width: 550 }}>
                                            (v) Others
                                        </TableCell>
                                        <TableCell align="center">Kilolitres</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            - No treatment
                                        </TableCell>
                                        <TableCell align="center">Kilolitres</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            - With treatment - please specify level of treatment
                                        </TableCell>
                                        <TableCell align="center">Kilolitres</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            <strong>Total water discharged (in Kilolitres)</strong>
                                        </TableCell>
                                        <TableCell align="center"><strong>Kilolitres</strong></TableCell>
                                        <TableCell align="center"><strong>–</strong></TableCell>
                                        <TableCell align="center"><strong>30,248</strong></TableCell>
                                    </TableRow>

                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box mb={5} mt={2}>
                            <Typography variant='body2'>
                                * As part of its commitment to environmental stewardship, the Company has initiated wastewater recycling to prevent any water discharge.
                                <br></br><br></br>
                                <strong>Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N) If yes, name of the external agency.</strong>
                                <br></br>
                                Yes, DNV Business Assurance India Private Limited
                            </Typography>
                        </Box>
                    </Box>
                </Collapse>
            </Box>


            <Box mt={4} mb={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        5. Has the entity implemented a mechanism for Zero Liquid Discharge? If yes, provide details of its coverage and implementation
                        <ExpandMore
                            expand={expanded4}
                            onClick={handleExpandClick4}
                            aria-expanded={expanded4}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded4} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            <ul>
                                <li>Yes, the entity has implemented Zero Liquid Discharge (ZLD) mechanisms as part of its environmental management strategy. Select manufacturing plants are equipped with dedicated ZLD infrastructure.</li>
                                <li>Currently, zero water is discharged from our plants. Domestic wastewater is recycled through STP (Sewage Treatment Plant) and process wastewater through ETP (Effluent Treatment Plant). Each STP and ETP has got 3 levels of treatment i.e., Primary, Secondary, and Tertiary, followed by advance treatment procedures like Ultra Filtration, Nano Filtration &amp; Reverse Osmosis (RO).</li>
                                <li>Currently, 34% of the freshwater requirement is met through recycled water, demonstrating effective water stewardship and continuous improvement in water circularity.</li>
                                <li>A unique waste heat–based evaporator system has been deployed as part of the ZLD infrastructure in Nashik Plant for the first time. This system offsets 50% of Nashik Freshwater requirement &amp; also operates at 60% lesser power compared to conventional evaporators.</li>
                                <li>Reuse of water in process areas like pretreatment, water leak testing, etc. and in Toilets urinals &amp; flush requirement are maximized, thereby optimizing the freshwater requirement.</li>
                            </ul>
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={4} mb={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        6. Please provide details of air emissions (other than GHG emissions) by the entity, in the following format
                        <ExpandMore
                            expand={expanded5}
                            onClick={handleExpandClick5}
                            aria-expanded={expanded5}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded5} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" aria-label="Water withdrawal">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell sx={{ minWidth: 300 }}><strong>Parameter</strong></TableCell>
                                        <TableCell align="center" sx={{ minWidth: 100 }}><strong>Please specify unit </strong></TableCell>
                                        <TableCell align="center"><strong>FY 2025-26*</strong></TableCell>
                                        <TableCell align="center"><strong>FY 2024-25</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">NOx</TableCell>
                                        <TableCell align="center">MT</TableCell>
                                        <TableCell align="center">156.9</TableCell>
                                        <TableCell align="center">14.15</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">SOx</TableCell>
                                        <TableCell align="center">MT</TableCell>
                                        <TableCell align="center">37.1</TableCell>
                                        <TableCell align="center">9.8</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Particulate matter (PM)</TableCell>
                                        <TableCell align="center">MT</TableCell>
                                        <TableCell align="center">125.52</TableCell>
                                        <TableCell align="center">13.20</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Persistent organic pollutants (POP)</TableCell>
                                        <TableCell align="center">MT</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Volatile organic compounds (VOC)</TableCell>
                                        <TableCell align="center">MT</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Hazardous air pollutants (HAP)</TableCell>
                                        <TableCell align="center">MT</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Others</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                    </TableRow>
                                </TableBody>

                            </Table>
                        </TableContainer>
                        <Box mb={5} mt={2}>
                            <Typography variant='body2'>
                                * The increase in FY26 figures is attributable to improvements in reporting processes and expanded coverage.
                                <br></br><br></br>
                                <strong>Note: Indicate if any independent assessment/ evaluation/ assurance hasbeen carried out by an external agency? (Y/N) If yes, name of the external agency:</strong>
                                <br></br>
                                Yes, DNV Business Assurance India Private Limited
                            </Typography>
                        </Box>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={4} mb={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        7. Provide details of Greenhouse Gas emissions (Scope 1 and Scope 2 emissions) & its intensity, in the following format
                        <ExpandMore
                            expand={expanded6}
                            onClick={handleExpandClick6}
                            aria-expanded={expanded6}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded6} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" aria-label="Water withdrawal">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell><strong>Parameter</strong></TableCell>
                                        <TableCell align="center"><strong>Unit</strong></TableCell>
                                        <TableCell align="center"><strong>FY 2025-26</strong></TableCell>
                                        <TableCell align="center"><strong>FY 2024-25</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Total Scope 1 emissions (Break-up of the GHG into CO2, CH4, N2O, HFCs, PFCs, SF6, NF3, if available)
                                        </TableCell>
                                        <TableCell align="center">Metric tonnes of CO2 equivalent</TableCell>
                                        <TableCell align="center">80,319</TableCell>
                                        <TableCell align="center">67,829</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Total Scope 2 emissions (Break-up of the GHG into CO2, CH4, N2O, HFCs, PFCs, SF6, NF3, if available)
                                        </TableCell>
                                        <TableCell align="center">Metric tonnes of CO2 equivalent</TableCell>
                                        <TableCell align="center">2,41,210</TableCell>
                                        <TableCell align="center">2,49,830</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Total Scope 1 &amp; Scope 2 emissions
                                        </TableCell>
                                        <TableCell align="center">Metric tonnes of CO2 equivalent</TableCell>
                                        <TableCell align="center">3,21,529</TableCell>
                                        <TableCell align="center">3,17,659</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            <strong>Total Scope 1 and Scope 2 emissions intensity per rupee of turnover</strong><br />
                                            (Total Scope 1 and Scope 2 GHG emissions/ Revenue from operations)
                                        </TableCell>
                                        <TableCell align="center">MT of CO2e Cr. Rupee of turnover</TableCell>
                                        <TableCell align="center">2.21</TableCell>
                                        <TableCell align="center">2.73</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            <strong>Total Scope 1 and Scope 2 emissions intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP)*</strong><br />
                                            (Total Scope 1 and Scope 2 GHG emissions/ Revenue from operations adjusted for PPP)
                                        </TableCell>
                                        <TableCell align="center">MT of CO2e Cr. Rupee of turnover adjusted for Purchasing Power Parity</TableCell>
                                        <TableCell align="center">44.92</TableCell>
                                        <TableCell align="center">56.34</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            <strong>Total Scope 1 and Scope 2 emissions intensity in terms of physical output</strong>
                                        </TableCell>
                                        <TableCell align="center">
                                            MT of CO2 equivalent Eq Vehicle<br />
                                            MT of CO2e Eq Tractor<br />
                                            MT of CO2e Ton of packaging
                                        </TableCell>
                                        <TableCell align="center">
                                            Auto Sector: 0.089<br />
                                            Farm Sector: 0.073<br />
                                            Spares Business Units: 0.102
                                        </TableCell>
                                        <TableCell align="center">
                                            Auto Sector: 0.101<br />
                                            Farm Sector: 0.163<br />
                                            Spares Business Units: 0.107
                                        </TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            <strong>Total Scope 1 and Scope 2 emission intensity</strong> (optional) - the relevant metric may be selected by the entity
                                        </TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>
                                </TableBody>

                            </Table>
                        </TableContainer>
                        <Box mb={5} mt={2}>
                            <Typography variant='body2'>
                                * For India PPP conversion factor is 20.34 &amp; 20.66 for the year 2026 and 2025 respectively as per Implied PPP conversion rate available at <a href="https://www.imf.org/external/datamapper/PPPEX@WEO/OEMDC/IND" target="_blank" rel="noopener noreferrer">https://www.imf.org/external/datamapper/PPPEX@WEO/OEMDC/IND</a>
                                <br></br><br></br>
                                <strong>Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N) If yes, name of the external agency.</strong>
                                <br></br>
                                Yes, DNV Business Assurance India Private Limited
                            </Typography>
                        </Box>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={4} mb={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        8. Does the entity have any project related to reducing Greenhouse Gas emission? If Yes, then provide details.
                        <ExpandMore
                            expand={expanded7}
                            onClick={handleExpandClick7}
                            aria-expanded={expanded7}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded7} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1' sx={{ textAlign: "justify" }}>
                            <ul style={{ 'marginTop': 0 }}>
                                <li>Yes, the Company is committed to becoming Carbon Neutral by 2040. It is also committed for Science Based Target (SBT) to de-carbonize its growth and thus contributing to keep global temperature rise below 2 degrees Celsius as per Paris accord 2015.</li>
                                <li>The Company has a robust roadmap for achieving these commitments through improvement in energy efficiency and adoption of renewable energy.</li>
                                <li>Few of the initiatives to reduce Green House Gas emission are mentioned below:</li>
                                <ul>
                                    <li>Adoption of Renewable energy through solar and windmills.</li>
                                    <li>Adoption of clean energy i.e., through switching over from HSD to PNG.</li>
                                    <li>Replacement of conventional air circulators with BLDC technology air circulators.</li>
                                    <li>Radiant cooling system to optimize the HVAC operating load.</li>
                                    <li>Replacement of old conventional lights with LEDs.</li>
                                    <li>Installation of energy efficient air compressor.</li>
                                    <li>Replacement of old motors with premium efficiency IE3 motors.</li>
                                    <li>Installation of Energy efficient inverter split ACs.</li>
                                    <li>Installation of auto shut off valves for compressed air.</li>
                                    <li>Waste heat recovery from air compressors.</li>
                                    <li>Installation of IT guns for spot welding.</li>
                                </ul>
                            </ul>
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={4} mb={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        9. Provide details related to waste management by the entity, in the following format
                        <ExpandMore
                            expand={expanded8}
                            onClick={handleExpandClick8}
                            aria-expanded={expanded8}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded8} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" aria-label="Water withdrawal">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell><strong>Parameter</strong></TableCell>
                                        <TableCell align="center"><strong>FY 2025-26</strong></TableCell>
                                        <TableCell align="center"><strong>FY 2024-25</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow>
                                        <TableCell component="th" scope="row" sx={{ width: 550, backgroundColor: "#e6e7e8" }} colSpan={3}>
                                            <strong>Total Waste Generated (in metric tonnes)</strong>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Plastic waste (A)</TableCell>
                                        <TableCell align="center">9,321</TableCell>
                                        <TableCell align="center">8,067</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>E-waste (B)</TableCell>
                                        <TableCell align="center">482</TableCell>
                                        <TableCell align="center">288</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Bio-medical waste (C)</TableCell>
                                        <TableCell align="center">0.35</TableCell>
                                        <TableCell align="center">0.225</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Construction and demolition waste (D)</TableCell>
                                        <TableCell align="center">455</TableCell>
                                        <TableCell align="center">411</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Battery waste (E)</TableCell>
                                        <TableCell align="center">433</TableCell>
                                        <TableCell align="center">228</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Radioactive waste (F)</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Other Hazardous waste. Please specify, if any (G)</TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>- Paint sludge</TableCell>
                                        <TableCell align="center">2,491</TableCell>
                                        <TableCell align="center">1,726</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>- Phosphate sludge</TableCell>
                                        <TableCell align="center">395</TableCell>
                                        <TableCell align="center">219</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>- ETP Sludge</TableCell>
                                        <TableCell align="center">1,513</TableCell>
                                        <TableCell align="center">1,437</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>- Other (Oil, oil-soaked waste, grinding mud, hazardous waste containers etc.)</TableCell>
                                        <TableCell align="center">8,296</TableCell>
                                        <TableCell align="center">6,644</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            Other Non-hazardous waste generated. Please specify, if any (H)<br />
                                            (Break-up by composition i.e., by materials relevant to the sector)
                                        </TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>- Foundry sand</TableCell>
                                        <TableCell align="center">70,417</TableCell>
                                        <TableCell align="center">63,912</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>- Metal scrap (Aluminium, Mild Steel, Copper, Steel etc)</TableCell>
                                        <TableCell align="center">85,806</TableCell>
                                        <TableCell align="center">83,771</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>- Other (Cardboard, wood, food waste etc.)</TableCell>
                                        <TableCell align="center">32,503</TableCell>
                                        <TableCell align="center">28,959</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell><strong>Total (A + B + C + D + E + F + G + H)</strong></TableCell>
                                        <TableCell align="center"><strong>2,12,113</strong></TableCell>
                                        <TableCell align="center"><strong>1,95,663</strong></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <strong>Waste intensity per rupee of turnover</strong><br />
                                            (Total waste generated / Revenue from operations)
                                        </TableCell>
                                        <TableCell align="center"><strong>1.46</strong></TableCell>
                                        <TableCell align="center"><strong>1.68</strong></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <strong>Waste intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP)^</strong><br />
                                            (Total waste generated/ Revenue from operations adjusted for PPP)
                                        </TableCell>
                                        <TableCell align="center"><strong>29.64</strong></TableCell>
                                        <TableCell align="center"><strong>34.70</strong></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            Waste intensity in terms of physical output<br />
                                            (MT/ Eq Vehicle, MT/ Eq Tractor, MT/ Ton of packaging)
                                        </TableCell>
                                        <TableCell align="center">
                                            Auto Sector:<br />
                                            0.061<br />
                                            Farm Sector:<br />
                                            0.101<br />
                                            Spares Business Units:<br />
                                            0.219
                                        </TableCell>
                                        <TableCell align="center">
                                            **Auto Sector:<br />
                                            0.0738<br />
                                            Farm Sector:<br />
                                            0.111<br />
                                            Spares Business Units:<br />
                                            0.225
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell><strong>Waste intensity</strong> (optional) – the relevant metric may be selected by the entity.</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell align="center" colSpan={3} sx={{ backgroundColor: "#e6e7e8" }}>
                                            <strong>
                                                For each category of waste generated, total waste recovered through recycling, re-using or other recovery operations (in metric tonnes)
                                            </strong>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row" sx={{ width: 550 }} colSpan={3}>
                                            <strong>Category of waste</strong>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>(i) Recycled</TableCell>
                                        <TableCell align="center">1,34,946</TableCell>
                                        <TableCell align="center">1,26,113.08</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>(ii) Re-used</TableCell>
                                        <TableCell align="center">53,575*</TableCell>
                                        <TableCell align="center">1,706.04</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>(iii) Other recovery operations</TableCell>
                                        <TableCell align="center">2,584</TableCell>
                                        <TableCell align="center">1,928.63</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell><strong>Total</strong></TableCell>
                                        <TableCell align="center"><strong>1,91,105</strong></TableCell>
                                        <TableCell align="center"><strong>1,29,747.75</strong></TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell align="center" colSpan={3} sx={{ backgroundColor: "#e6e7e8" }}>
                                            <strong>
                                                For each category of waste generated, total waste disposed by nature of disposal method (in metric tonnes)
                                            </strong>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row" sx={{ width: 550 }} colSpan={3}>
                                            <strong>Category of waste</strong>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>(i) Incineration</TableCell>
                                        <TableCell align="center">2,582</TableCell>
                                        <TableCell align="center">1,999</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>(ii) Landfilling</TableCell>
                                        <TableCell align="center">18,426</TableCell>
                                        <TableCell align="center">63,916.74</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>(iii) Other disposal operations</TableCell>
                                        <TableCell align="center">0</TableCell>
                                        <TableCell align="center">0</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell><strong>Total</strong></TableCell>
                                        <TableCell align="center"><strong>21,008</strong></TableCell>
                                        <TableCell align="center"><strong>65,915.34</strong></TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Box mb={5} mt={2}>
                            <Typography variant='body2'>
                                * During FY26, the Company undertook targeted actions to enhance the reuse of foundry sand generated from operations. These initiatives led to a significant increase in waste reused and helped divert material from landfill, supporting improved resource efficiency.
                                <br></br><br></br>
                                ** In FY25, waste intensity was reported in kg per equivalent vehicle, kg per equivalent tractor, and kg per tonne of packaging. In FY26, the units have been restated to metric tonnes per equivalent vehicle, metric tonnes per equivalent tractor, and metric tonnes per tonne of packaging.
                                <br></br><br></br>
                                ^ For India PPP conversion factor is 20.34 &amp; 20.66 for the year 2026 and 2025 respectively as per Implied PPP conversion rate available at <a href='https://www.imf.org/external/datamapper/PPPEX@WEO/OEMDC/IND'>https://www.imf.org/external/datamapper/PPPEX@WEO/OEMDC/IND</a>
                                <br></br><br></br>
                                <strong>Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N) If yes, name of the external agency.</strong>
                                <br></br>
                                Yes, DNV Business Assurance India Private Limited
                            </Typography>
                        </Box>
                    </Box>
                </Collapse>
            </Box >
            <Box mt={4} mb={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        10. Briefly describe the waste management practices adopted in your establishments. Describe the strategy adopted by your company to reduce usage of hazardous and toxic chemicals in your products
                        and processes and the practices adopted to manage such wastes.
                        <ExpandMore
                            expand={expanded9}
                            onClick={handleExpandClick9}
                            aria-expanded={expanded9}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded9} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1' sx={{ textAlign: "justify" }}>
                            <ul>
                                <li>The Company has a robust waste management process and aims to be Zero Waste to Landfill for all its sites by 2030.</li>
                                <li>The Company’s approach to waste management is that of a circular economy aimed at eliminating waste and the continual use of resources. In a circular economy, waste materials and energy become input for other processes or as regenerative resources for nature.</li>
                                <li>The Company is committed to responsible disposal as per all applicable norms, leading to better ecosystems. When the waste diversion rate for any company is 99% or more then it can be declared as “Zero Waste to Landfill”.</li>
                                <li>Landfill diversion can occur through recycling which can include glass, paper, metal, plastic, textile, or electronics (E-Waste), lead batteries etc.</li>
                                <li>Organic Waste can be diverted to biological treatment through which the waste is reused. Another method is the thermal treatment (incineration) with the generation of power.</li>
                                <li>Hazardous waste such as paint sludge, oily cotton waste can be diverted to coprocessing operation, which can be reused as a resource (fuel) for cement industries. It can be also recycled as raw material.</li>
                                <li>Food waste generated at manufacturing plants are moved to the biogas plant for biogas generation. All the non-hazardous waste, which is generated inside the plant like metal, non-metal parts are being recycled.</li>
                                <li>Implementing “Zero Waste to Landfill” program resulted in not only environmental benefit but also in business benefit. The Company started looking at all the Company’s waste as a valuable resource and started converting it into wealth. This is also called Waste Circular Economy in which the Company’s waste is used as a resource for someone.</li>
                            </ul>
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={4} mb={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        11. If the entity has operations/ offices in/ around ecologically sensitive areas (such as national parks, wildlife sanctuaries, biosphere reserves, wetlands, biodiversity hotspots, forests, coastal regulation
                        zones etc.) where environmental approvals/ clearances are required, please specify details in the following format:

                        <ExpandMore
                            expand={expanded10}
                            onClick={handleExpandClick10}
                            aria-expanded={expanded10}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded10} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" aria-label="Water withdrawal">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell><strong>S.No.</strong></TableCell>
                                        <TableCell><strong>Location of operations/ offices</strong></TableCell>
                                        <TableCell><strong>Type of operations</strong></TableCell>
                                        <TableCell><strong>Whether the conditions of environmental approval/ clearance are being complied
                                            with? (Y/N) If no, the reasons thereof and corrective action taken, if any.</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            -
                                        </TableCell>
                                        <TableCell>NA</TableCell>
                                        <TableCell>NA</TableCell>
                                        <TableCell>NA</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={4} mb={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        12. Details of environmental impact assessments of projects undertaken by the entity based on applicable laws, in the current financial year:
                        <ExpandMore
                            expand={expanded11}
                            onClick={handleExpandClick11}
                            aria-expanded={expanded11}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded11} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" aria-label="Water withdrawal">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell><strong>Name and brief details of project</strong></TableCell>
                                        <TableCell><strong>EIA Notification No.</strong></TableCell>
                                        <TableCell><strong>Date</strong></TableCell>
                                        <TableCell><strong>Whether conducted by
                                            independent external agency
                                            (Yes/ No)</strong></TableCell>
                                        <TableCell><strong>Results communicated in
                                            public domain
                                            (Yes/ No)
                                        </strong></TableCell>
                                        <TableCell><strong>Relevant Web link
                                        </strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            NA
                                        </TableCell>
                                        <TableCell>NA</TableCell>
                                        <TableCell>NA</TableCell>
                                        <TableCell>NA</TableCell>
                                        <TableCell>NA</TableCell>
                                        <TableCell>NA</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={4} mb={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        13. Is the entity compliant with the applicable environmental law/ regulations/ guidelines in India; such as the Water (Prevention and Control of Pollution) Act, Air (Prevention and Control of Pollution)
                        Act, Environment protection act and rules thereunder (Y/N). If not, provide details of all such non-compliances, in the following format:
                        <ExpandMore
                            expand={expanded12}
                            onClick={handleExpandClick12}
                            aria-expanded={expanded12}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded12} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1' sx={{ textAlign: "justify" }}>
                            Yes
                        </Typography>
                    </Box>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" aria-label="Water withdrawal">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell><strong>S.No.</strong></TableCell>
                                        <TableCell><strong>Specify the law/ regulation/ guidelines which
                                            was not complied with</strong></TableCell>
                                        <TableCell><strong>Provide details of the non-compliance</strong></TableCell>
                                        <TableCell><strong>Any fines/ penalties/ action taken by regulatory
                                            agencies such as pollution control boards or by
                                            courts</strong></TableCell>
                                        <TableCell><strong>Corrective action taken if any
                                        </strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            -
                                        </TableCell>
                                        <TableCell>NA</TableCell>
                                        <TableCell>NA</TableCell>
                                        <TableCell>NA</TableCell>
                                        <TableCell>NA</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={6}>
                <Typography className='heading' variant='h4' sx={{ fontSize: '28px', color: "#e31837" }}>
                    Leadership Indicators
                </Typography>
            </Box>
            <Box mt={4} mb={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        1. Water withdrawal, consumption and discharge in areas of water stress (in Kiloliters).
                        <ExpandMore
                            expand={expanded15}
                            onClick={handleExpandClick15}
                            aria-expanded={expanded15}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded15} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 900 }} size="small" aria-label="Water withdrawal">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={2}><strong>(i) Name of the area</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={2} align="center"><strong>Jaipur</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={2} align="center"><strong>Mohali</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={2} align="center"><strong>Pithampur</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={2} align="center"><strong>Chennai</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={2} rowSpan={2} align="center"><strong>Total</strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={2} ><strong>(ii) Nature of operations</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={2} align="center"><strong>Manufacturing</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={2} align="center"><strong>Manufacturing</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={2} align="center"><strong>Manufacturing </strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={2} align="center"><strong>Manufacturing </strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell colSpan={2}><strong>(iii) Water withdrawal,
                                            consumption and
                                            discharge in the following
                                            format:</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={3} align="center"><strong>FY 2025-26<br />(Current Financial Year)</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={3} align="center"><strong>FY 2024-25<br />(Previous Financial Year)</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={3} align="center"><strong>FY 2025-26<br />(Current Financial Year)</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={3} align="center"><strong>FY 2024-25<br />(Previous Financial Year)</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={3} align="center"><strong>FY 2025-26<br />(Current Financial Year)</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={3} align="center"><strong>FY 2024-25<br />(Previous Financial Year)</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={3} align="center"><strong>FY 2025-26<br />(Current Financial Year)</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={3} align="center"><strong>FY 2024-25<br />(Previous Financial Year)</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={3} align="center"><strong>FY 2025-26<br />(Current Financial Year)</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={3} align="center"><strong>FY 2024-25<br />(Previous Financial Year)</strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }}><strong>Parameter</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }}><strong>Please
                                            specify
                                            unit</strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={2} align="center"><strong>Water withdrawal by source <br /> (in Kilolitres)</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }}>Surface water</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">0</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">0</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }}>Groundwater</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">4,197</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">3,643</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">2,58,547</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">1,97,631</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">2,62,744</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">2,01,274</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }}>Third-parties</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">18,699</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">25,469</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">750</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">824</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">53,460</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">30,625</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">1,41,240</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">1,19,950</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">2,14,149</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">1,76,868</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }}>Seawater / desalinated water</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }}>Others</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">–</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">21,542</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">27,228</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">21,542</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">27,228</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }}>Total volume of water withdrawal (in kilolitres)</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">22,896</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">29,112</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">2,59,297</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">1,98,455</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">53,460</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">30,625</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">1,62,782</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">1,47,178</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">4,98,435</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">4,05,369</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }}>Total volume of water consumption (in kilolitres)</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">22,896</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">29,112</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">2,59,297</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">1,98,455</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">53,460</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">30,625</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">1,62,782</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">1,47,178</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">4,98,435</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">4,05,369</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }}>
                                            Water intensity per rupee of turnover (Water consumed / turnover)
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">
                                            Kilolitres/ Cr. rupees of turnover
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={8} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">3.4</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">3.5</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }}>
                                            Water intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP)* (Water consumed / turnover adjusted for PPP)
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">
                                            Kilolitres/ Cr. rupees of turnover adjusted for Purchasing Power Parity (PPP)
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={8} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">69.64</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">71.9</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }}>
                                            Water intensity (optional) - the relevant metric may be selected by the entity
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={8} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD", width: 550, backgroundColor: "#e6e7e8" }} component="th" scope="row" colSpan={14}>
                                            <strong>Water discharge by destination and level of treatment (in Kilolitres)
                                            </strong>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD", width: 550 }} component="th" scope="row">
                                            (i) Into Surface water
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} component="th" scope="row">
                                            - No treatment
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} component="th" scope="row">
                                            - With treatment - please specify level of treatment
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">-</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD", width: 550 }} component="th" scope="row">
                                            (ii) Into Groundwater
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={10} align="center">-</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} component="th" scope="row">
                                            - No treatment
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={10} align="center">-</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} component="th" scope="row">
                                            - With treatment - please specify level of treatment
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={10} align="center">-</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD", width: 550 }} component="th" scope="row">
                                            (iii) Into Seawater
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={10} align="center">-</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} component="th" scope="row">
                                            - No treatment
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={10} align="center">-</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} component="th" scope="row">
                                            - With treatment - please specify level of treatment
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={10} align="center">-</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD", width: 550 }} component="th" scope="row">
                                            (iv) Sent to third parties
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={10} align="center">-</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} component="th" scope="row">
                                            - No treatment
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={10} align="center">-</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} component="th" scope="row">
                                            - With treatment - please specify level of treatment
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={10} align="center">-</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD", width: 550 }} component="th" scope="row">
                                            (v) Others
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={10} align="center">-</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} component="th" scope="row">
                                            - No treatment
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={10} align="center">-</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} component="th" scope="row">
                                            - With treatment - please specify level of treatment
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={10} align="center">-</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} component="th" scope="row">
                                            Total water discharged (in kilolitres)
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center">Kilolitres</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={10} align="center">-</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Box mb={5} mt={2}>
                            <Typography variant='body2'>
                                The Company prioritises reducing its dependence on freshwater by investing in advanced wastewater recycling technologies and by fostering water-conscious behaviour at the workplace. At its Mohali facility, these efforts have resulted in an annual water savings of 4,450 KL. These initiatives reflect a deliberate effort to conserve water where it matters most and to operate responsibly in resource-constrained regions.
                                <br /><br />
                                <strong>Note: Indicate if any independent assessment/ evaluation/ assurance hasbeen carried out by an external agency? (Y/N) If yes, name of the external agency:</strong><br></br>
                                Yes, DNV Business Assurance India Private Limited
                            </Typography>
                        </Box>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={4} mb={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        2. Please provide details of total Scope 3 emissions & its intensity, in the following format:
                        <ExpandMore
                            expand={expanded16}
                            onClick={handleExpandClick16}
                            aria-expanded={expanded16}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded16} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" aria-label="Water withdrawal">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell><strong>Parameter</strong></TableCell>
                                        <TableCell align="center"><strong>Unit</strong></TableCell>
                                        <TableCell align="center"><strong>FY 2025-26</strong></TableCell>
                                        <TableCell align="center"><strong>FY 2024-25</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Total Scope 3 emissions (Break-up of the GHG into CO2, CH4, N2O, HFCs, PFCs,
                                            SF6, NF3, if available)
                                        </TableCell>
                                        <TableCell align="center">
                                            Metric tonnes of CO2 equivalent
                                        </TableCell>
                                        <TableCell align="center">12,37,05,567*</TableCell>
                                        <TableCell align="center">9,45,16,227</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Total Scope 3 emissions per rupee of turnover
                                        </TableCell>
                                        <TableCell align="center">
                                            Metric tonnes of CO2 equivalent/ per Crore rupees of turnover
                                        </TableCell>
                                        <TableCell align="center">
                                            849.77
                                        </TableCell>
                                        <TableCell align="center">
                                            811.41
                                        </TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Total Scope 3 emission intensity (optional) - the relevant metric may be selected by the entity
                                        </TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                        <TableCell align="center">–</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Box mb={5} mt={2}>
                            <Typography variant='body2'>
                                * The rise in Scope 3 emissions is driven by an expansion in reporting coverage. During FY26, the Company included emissions from the Trucks and Buses business, a growing business area, which significantly contributed to the overall increase.
                                <br></br><br></br>
                                <strong>Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N) If yes, name of the external agency.</strong>
                                <br></br>
                                Yes, DNV Business Assurance India Private Limited
                            </Typography>
                        </Box>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={4} mb={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        3. With respect to the ecologically sensitive areas reported at Question 10 of Essential Indicators above, provide details of significant direct & indirect impact of the entity on biodiversity in such areas
                        along-with prevention and remediation activities.
                        <ExpandMore
                            expand={expanded17}
                            onClick={handleExpandClick17}
                            aria-expanded={expanded17}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded17} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1' sx={{ textAlign: "justify" }}>
                            Not Applicable
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={4} mb={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        4. If the entity has undertaken any specific initiatives or used innovative technology or solutions to improve resource efficiency, or reduce impact due to emissions/ effluent discharge/ waste generated,
                        please provide details of the same as well as outcome of such initiatives, as per the following format:
                        <ExpandMore
                            expand={expanded18}
                            onClick={handleExpandClick18}
                            aria-expanded={expanded18}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded18} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" aria-label="Water withdrawal">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell sx={{ width: '5%' }} align="center"><strong>Sr. No.</strong></TableCell>
                                        <TableCell sx={{ width: '20%' }}><strong>Initiative undertaken</strong></TableCell>
                                        <TableCell sx={{ width: '50%' }}><strong>Details of the initiative (Web-link, if any, may be provided along-with summary)</strong></TableCell>
                                        <TableCell sx={{ width: '25%' }}><strong>Outcome of the initiative</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center'>
                                            1
                                        </TableCell>
                                        <TableCell>
                                            Adoption of renewable energy - Group Captive solar
                                        </TableCell>
                                        <TableCell>
                                            76 MWp Group Captive Solar Project was implemented for Maharashtra plants, which is expected to generate 100 million Units a year. The project was commissioned on 1st April 2022.
                                        </TableCell>
                                        <TableCell>
                                            Reduction of GHG emissions &amp; Reduction in energy costs
                                        </TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center'>
                                            2
                                        </TableCell>
                                        <TableCell>
                                            Adoption of renewable energy - Rooftop Solar
                                        </TableCell>
                                        <TableCell>
                                            In past 4-5 years, 18 MWp rooftop solar is implemented in totality across the manufacturing sites of the Company.
                                        </TableCell>
                                        <TableCell>
                                            Reduction of GHG emissions &amp; Reduction in energy costs
                                        </TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center'>
                                            3
                                        </TableCell>
                                        <TableCell>
                                            Adoption of renewable energy – Windmill
                                        </TableCell>
                                        <TableCell>
                                            The Company has implemented 6.3 MW windmills for captive consumption in Maharashtra (through own capex).<br />
                                            In FY 2025-26, 35 MW Wind short-term power was consumed across the Company's locations in Maharashtra.
                                        </TableCell>
                                        <TableCell>
                                            Reduction of GHG emissions &amp; Reduction in energy costs
                                        </TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center'>
                                            4
                                        </TableCell>
                                        <TableCell>
                                            Energy reduction
                                        </TableCell>
                                        <TableCell>
                                            The Company has undertaken several targeted initiatives aimed at improving energy efficiency and reducing emissions:
                                            <br /><br />
                                            1. Compressed Air Optimization: Replaced screw compressors with centrifugal compressors that are energy efficient and minimize maintenance costs, leading to 3% reduction in Kandivali plant use.
                                            <br />
                                            2. Energy efficient Blowers: Conventional blower replaced with energy efficient blowers and optimized based on load requirement, leading to 25% reduction in energy consumption.
                                            <br />
                                            3. Low temperature degrease chemical: Lowered temperature requirement for chemicals by 10 degrees, leading to 57% reduction in energy consumption from the equipment.
                                            <br />
                                            4. Electronically Computed Blowers: Replaced centrifugal blower to reduce energy consumption of air handling units, leading to a 12% reduction in energy consumption.
                                            <br />
                                            5. BLDC Fans: Replaced around 1700 air circulators/Fan with BLDC tech fans which saves more energy.
                                        </TableCell>
                                        <TableCell>
                                            Reduction of GHG emissions &amp; Reduction in energy costs
                                        </TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center'>
                                            5
                                        </TableCell>
                                        <TableCell>
                                            Wastewater recycling
                                        </TableCell>
                                        <TableCell>
                                            Targeted for reducing the water consumption by eliminating waste, arresting leakages, alternate processes. Waste Heat evaporator was implemented with Recycle RO system that reduces the dependency on freshwater and operated only with 50% less power than conventional ZLD. Freshwater consumption was reduced by 5%.
                                        </TableCell>
                                        <TableCell>
                                            Reduction of freshwater consumption
                                        </TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center'>
                                            6
                                        </TableCell>
                                        <TableCell>
                                            Waste Reduction
                                        </TableCell>
                                        <TableCell>
                                            The Company has undertaken several targeted initiatives aimed at reducing waste and improving resource efficiency:
                                            <br /><br />
                                            1. Sealant Dispensing System Optimization - Upgraded the conical follower plate to a flat follower plate, significantly reducing sealant residue (by 63%) and purging waste generated per barrel.
                                            <br />
                                            2. Extracted Oil Reuse in Metal Scrap Compaction – Achieved 98% oil recovery by implementation of a steel chip compaction process enabling efficient separation, purification, and reuse of extracted oil from metal scrap. Also, reduced oil spillage and transportation trips, with potential for deployment across plants.
                                            <br />
                                            3. Replaced standard clear-coat applicators (80–84% efficiency) with high-transfer-efficiency applicators, reducing overspray and improving material utilization (by 12%), leading to 15% reduction in VOC emissions.
                                            <br />
                                            4. Implemented process modifications in packaging and module lines, including optimized purging intervals, shorter cycle times, and refined sensor height settings. Deployed across module and powerpack areas.
                                        </TableCell>
                                        <TableCell>
                                            Reduction of operational waste and improvement in material efficiency
                                        </TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center'>
                                            7
                                        </TableCell>
                                        <TableCell>
                                            Optimizing plastic in packaging
                                        </TableCell>
                                        <TableCell>
                                            Carton boxes are converted into re-usable packaging material with the help of a shredder. Due to this initiative, plastic packaging is eliminated.
                                            <br /><br />
                                            Additionally, plastic wrapping used in wheel rim packaging was replaced with durable, reusable covers that circulate back to suppliers after each use, eliminating single-use plastic in the process. Packaging for glass and other components was also shifted from conventional polyethylene to compostable plastic, supporting sustainable material substitution across the Auto Division.
                                        </TableCell>
                                        <TableCell>
                                            These actions led to significant plastic waste reduction, full elimination of plastic in wheel-rim packaging, and conversion of 26% of the division’s plastic use to compostable alternatives.
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={4} mb={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        5. Does the entity have a business continuity and disaster management plan? Give details in 100 words/ web link.
                        <ExpandMore
                            expand={expanded19}
                            onClick={handleExpandClick19}
                            aria-expanded={expanded19}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded19} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1' sx={{ textAlign: "justify" }}>
                            The Company has prepared an Onsite Emergency Plan (OEP) / Disaster Control Plan (DCP). This emergency preparedness and response plan for manufacturing unit also includes all the risks and emergencies associated with manufacturing operations. The plan also contains processes towards its mitigation for these emergencies and this OEP plan is subject to regularly conducted mock drills. All these mock drills are scheduled as per the annual calendar. All the external as well as internal responsible stakeholders that are to be contacted in emergency situations are readily available with their respective contact numbers along with respective responsibility communication matrix.
                            <br /><br />
                            All emergency contact numbers for nearby hospitals and applicable government agencies are provided in the OEP/DCP. Designated assembly points considering the safety of the given headcount on a day-to-day basis are mentioned in the plan. Duration of each mock drill is recorded, so as to increase the effectiveness and decrease the time during each iteration. Scenario analysis with high-risk priority number (RPN) emergency and maximum severity is conducted in presence of government authorities and Mutual Aid Response Group (MARG) to demonstrate effectiveness.
                            <br /><br />
                            In addition to operational emergency preparedness, the Company has also conducted a climate risk assessment to identify physical and transition risks arising from climate change. This assessment helps in proactively identifying vulnerabilities that could impact operations—such as extreme weather events, regulatory shifts, or energy transition risks and mapping existing mitigation measures already in place.
                            <br /><br />
                            To further strengthen overall risk resilience, the Company has implemented an IT Operations and Risk Management Policy, which outlines protocols to manage and recover from potential disruptions to IT infrastructure, cyber threats, and data breaches. This ensures business continuity and safeguards critical operations across digital platforms.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={4} mb={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        6. Disclose any significant adverse impact to the environment, arising from the value chain of the entity. What mitigation or adaptation measures have been taken by the entity in this regard.
                        <ExpandMore
                            expand={expanded20}
                            onClick={handleExpandClick20}
                            aria-expanded={expanded20}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded20} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1' sx={{ textAlign: "justify" }}>
                            There were no significant risks/concerns noticed during onsite supplier assessments with regards to adverse environmental impact.
                            <br /><br />
                            The Company mitigates the risk of potential adverse impacts by requiring suppliers to comply with its Sustainable procurement policy and Supplier Code of Conduct.
                            <br /><br />
                            As a proactive measure, the company also conducts training and awareness programs on environmental impacts and sustainability as part of its broader ESG training initiatives.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={4} mb={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        7. Percentage of value chain partners (by value of business done with such partners) that were assessed for environmental impacts.
                        <ExpandMore
                            expand={expanded21}
                            onClick={handleExpandClick21}
                            aria-expanded={expanded21}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded21} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1' sx={{ textAlign: "justify" }}>
                            The Company enforces an ESG-aligned Supplier Code of Conduct and works with suppliers who share the Company’s values and culture of fair, ethical, and responsible business practices. Over a period, 95% of suppliers by its purchase value signed the Supplier Code of Conduct. M&amp;M enforces an ESG-aligned Supplier Code of Conduct that expects suppliers to adhere to environmental regulations while actively advancing sustainable and responsible environmental practices.
                            <br /><br />
                            The Company initiated environmental due diligence in FY 2023-24 which was continued through FY26. Cumulatively, due diligence has been completed for 68.1% of suppliers, by value, since FY24. During FY 2025-26 ESG due diligence was conducted for 11.9% of suppliers, by value. No suppliers assessed during the year were found to have caused any significant adverse environmental impact.
                            <br /><br />
                            The environmental due diligence of suppliers is aimed at strengthening environmental stewardship within the supply chain. It involves an assessment of impacts across areas such as resource consumption, regulatory compliance, and overall environmental performance. It also evaluates performance against key environmental parameters, including water and energy efficiency, hazardous material handling, and adherence to applicable environmental standards.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={4} mb={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        8. a. Green credits generated or procured by the entity
                        <ExpandMore
                            expand={expanded22}
                            onClick={handleExpandClick22}
                            aria-expanded={expanded22}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded22} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1' sx={{ textAlign: "justify" }}>
                            None
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={4} mb={5} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        8. b. Green credits generated or procured by top ten value chain partners (in terms of value of purchases and sales respectively)
                        <ExpandMore
                            expand={expanded23}
                            onClick={handleExpandClick23}
                            aria-expanded={expanded23}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded23} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1' sx={{ textAlign: "justify" }}>
                            None
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
        </Container >
    )
}


export default Sectionc6;